"use client";

import { useEffect } from "react";
import { reportBrowserFailure } from "@/lib/browser-telemetry";
import {
  isConvexPermissionDenied,
  PERMISSION_DENIED_MESSAGE,
} from "@/lib/convex-errors";

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    if (!isConvexPermissionDenied(error)) {
      reportBrowserFailure(error, "react.root-boundary");
    }
  }, [error]);

  const isPermissionDenied = isConvexPermissionDenied(error);

  return (
    <html lang="en">
      <body style={{ fontFamily: "system-ui, sans-serif", padding: "2rem" }}>
        {isPermissionDenied ? (
          <p style={{ color: "#6b7280", maxWidth: "28rem" }}>
            {PERMISSION_DENIED_MESSAGE}
          </p>
        ) : (
          <>
            <h2 style={{ marginBottom: "1rem" }}>Something went wrong</h2>
            <button
              type="button"
              style={{
                padding: "0.5rem 1rem",
                cursor: "pointer",
              }}
              onClick={() => reset()}
            >
              Try again
            </button>
          </>
        )}
      </body>
    </html>
  );
}
